'use strict';

exports.__esModule = true;

var _reactLoadable = require('react-loadable');

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  asyncCompile: function asyncCompile(options) {
    var AsyncComponent = (0, _reactLoadable2.default)(options);
    return this.fold(function (hoc) {
      return hoc(AsyncComponent);
    });
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-crate/lib/loadable.js
// module id = trYE
// module chunks = 1